export const techniquesMessage = `Which of the following best describes the analytical techniques that your enterprise 
can deploy into production use cases?`;

const techniquesQ1 = `Mostly ad hoc, simple math, extrapolation, trending.`;

const techniquesQ2 = `Basic statistics, segmentation, database querying, tabulations of key metrics are leveraged to 
gain insights.`;

const techniquesQ3 = `Simple predictive analytics, classifications and clustering; dynamic forecasts.`;

const techniquesQ4 = `Advanced predictive methods deployed to discover insights; advanced optimization, sentiment 
analytics, text and image analytics.`;

const techniquesQ5 = `Neural nets and deep learning, genetic algorithms, advanced machine learning.`;

export const techniquesQuestions = [ techniquesQ1, techniquesQ2, techniquesQ3, techniquesQ4, techniquesQ5 ];
export const techniquesQuestionWeight = 0.08;
export const techniquesQuestionsScore = [ 0.08, 0.16, 0.24, 0.32, 0.40 ];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/delta/data/techniquesData.ts